import { SuspenseQueryWith } from '@/utils/types'
import { SpotUniverse } from '@nktkas/hyperliquid'
import { type UseQueryResult, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import { HyperCoreAsset, HyperCoreAssetsType, hyperCoreAssetsQueryOptions } from './querySpotMeta'

export type UseHyperCoreSpotMetaResult = SuspenseQueryWith<{
  assets: HyperCoreAsset[]
  universe: SpotUniverse[]
}>

export type UseHyperCoreSpotMetaQueryResult = Omit<
  UseQueryResult<{ assets: HyperCoreAsset[]; universe: SpotUniverse[] }>,
  'data'
> & {
  assets: HyperCoreAsset[]
  universe: SpotUniverse[]
}

export function useHyperCoreSpotMeta(type?: HyperCoreAssetsType): UseHyperCoreSpotMetaResult {
  const response = useSuspenseQuery({
    ...hyperCoreAssetsQueryOptions(type),
  })

  return {
    ...response,
    assets: response.data.assets,
    universe: response.data.universe,
  }
}

export function useHyperCoreSpotMetaQuery(type?: HyperCoreAssetsType): UseHyperCoreSpotMetaQueryResult {
  const response = useQuery({
    ...hyperCoreAssetsQueryOptions(type),
  })

  return {
    ...response,
    assets: response.data?.assets ?? [],
    universe: response.data?.universe ?? [],
  }
}
